import React from 'react'
import { connect } from 'react-redux'
import { RemixLoader } from 'remix/src/loader'

import './index.scss'

const remixTemplateUrl = process.env.REACT_APP_REMIX_URL + '/remix.html'

const DEVICES = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
}

class PreviewTab extends React.Component {
    constructor(props) {
        super(props)

        const {
            data: {
                project: { projectStructureJson },
            },
        } = props

        let homePageHasBlocks = false

        if (projectStructureJson.hasOwnProperty('pages')) {
            homePageHasBlocks = projectStructureJson.pages[0].blocks.length
        }

        this.state = {
            device: DEVICES.DESKTOP,
            hasBlocks: homePageHasBlocks,
        }
        this.previewRef = React.createRef()
        this.remixLoader = null
    }

    componentDidMount() {
        this.createIframe()
    }
    componentWillUnmount() {
        this.destroyIframe()
    }

    createIframe = () => {
        const { hasBlocks, device } = this.state
        if (!hasBlocks) return

        const {
            data: {
                project: { id, projectId, projectStructureJson },
            },
            language,
            imagesBucketUrl,
        } = this.props

        this.remixLoader = new RemixLoader({
            mode: 'preview',
            nodeElement: this.previewRef.current,
            remixUrl: remixTemplateUrl,
            projectId,
            projectNumericId: id,
            projectStructure: JSON.stringify(projectStructureJson),
            initialWidth: projectStructureJson.app.maxWidth,
            lng: language,
            additionalTopOffset: device === DEVICES.DESKTOP ? 102 : 0,
            imagesBucketUrl: imagesBucketUrl,
        })
        this.remixLoader.createIframe()
    }
    destroyIframe = () => {
        if (this.remixLoader) this.remixLoader.destroyIframe()
    }

    changeDevice = async value => {
        this.destroyIframe()
        await this.setState({
            device: value,
        })
        this.createIframe()
    }

    render() {
        const { device, hasBlocks } = this.state

        return (
            <div className="preview">
                {!hasBlocks ? (
                    <div className="no-blocks">
                        Your project does not contain any blocks on home page!
                        <br />
                        To view the project in the "Preview" mode please add blocks first
                    </div>
                ) : (
                    <>
                        <ul className="device-changer">
                            <li
                                className={`desktop${device === DEVICES.DESKTOP ? ' is-active' : ''}`}
                                onClick={() => this.changeDevice(DEVICES.DESKTOP)}
                            ></li>
                            <li
                                className={`mobile${device === DEVICES.MOBILE ? ' is-active' : ''}`}
                                onClick={() => this.changeDevice(DEVICES.MOBILE)}
                            ></li>
                        </ul>
                        <div className={`iframe_wrapper ${device}`}>
                            <div className={`iframe_inner`}>
                                <div ref={this.previewRef} />
                            </div>
                        </div>
                    </>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    language: state.language,
    imagesBucketUrl: state.user_details.imagesBucketUrl,
})

export default connect(mapStateToProps, null)(PreviewTab)
